// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Reply(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Reply" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 16.3536L3.64648 10L10 3.64648L11.7738 5.42029L8.43478 8.75004L17 8.75004C18.2427 8.75004 19.25 9.7574 19.25 11L19.25 20.25H16.75L16.75 11.25L8.43478 11.25L11.7738 14.5798L10 16.3536Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Reply.js.map